import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import PilierBaieCoulissante from "@/pages/services/baie-coulissante/PilierBaieCoulissante";
import RoulettesGalets from "@/pages/services/baie-coulissante/RoulettesGalets";
import BaieQuiCoince from "@/pages/services/baie-coulissante/BaieQuiCoince";
import RailBaie from "@/pages/services/baie-coulissante/RailBaie";
import ReglageBaie from "@/pages/services/baie-coulissante/ReglageBaie";
import SerrureCremone from "@/pages/services/baie-coulissante/SerrureCremone";
import RemplacementBaie from "@/pages/services/baie-coulissante/RemplacementBaie";
import DoubleVitrage from "@/pages/services/baie-coulissante/DoubleVitrage";
import PilierVoletRoulant from "@/pages/services/volet-roulant/PilierVoletRoulant";
import VoletBloque from "@/pages/services/volet-roulant/VoletBloque";
import VoletNeRemontePlus from "@/pages/services/volet-roulant/VoletNeRemontePlus";
import ReparationMoteur from "@/pages/services/volet-roulant/ReparationMoteur";
import ChangerSangle from "@/pages/services/volet-roulant/ChangerSangle";
import Motorisation from "@/pages/services/volet-roulant/Motorisation";
import VoletElectrique from "@/pages/services/volet-roulant/VoletElectrique";
import VoletSolaire from "@/pages/services/volet-roulant/VoletSolaire";
import PilierVitrier from "@/pages/services/vitrage/PilierVitrier";
import RemplacementVitreCassee from "@/pages/services/vitrage/RemplacementVitreCassee";
import RemplacementDoubleVitrage from "@/pages/services/vitrage/RemplacementDoubleVitrage";
import DoubleVitrageEmbue from "@/pages/services/vitrage/DoubleVitrageEmbue";
import VitrierUrgence from "@/pages/services/vitrage/VitrierUrgence";
import Miroiterie from "@/pages/services/vitrage/Miroiterie";
import Survitrage from "@/pages/services/vitrage/Survitrage";
import MentionsLegales from "@/pages/legal/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/legal/PolitiqueConfidentialite";
import Contact from "@/pages/legal/Contact";
import Merci from "@/pages/legal/Merci";
import PilierStore from "@/pages/services/store/PilierStore";
import StoreBanne from "@/pages/services/store/StoreBanne";
import StoreBanneBloque from "@/pages/services/store/StoreBanneBloque";
import MotorisationStore from "@/pages/services/store/MotorisationStore";
import ReparationBSO from "@/pages/services/store/ReparationBSO";
import StoreElectrique from "@/pages/services/store/StoreElectrique";
import PilierFenetre from "@/pages/services/fenetre/PilierFenetre";
import FenetreBloquee from "@/pages/services/fenetre/FenetreBloquee";
import ChangerCremone from "@/pages/services/fenetre/ChangerCremone";
import ChangerPoignee from "@/pages/services/fenetre/ChangerPoignee";
import ReglageOscilloBattant from "@/pages/services/fenetre/ReglageOscilloBattant";
import ChangerJoint from "@/pages/services/fenetre/ChangerJoint";
import FenetrePVCAluBois from "@/pages/services/fenetre/FenetrePVCAluBois";
import Montpellier from "@/pages/villes/Montpellier";
import Beziers from "@/pages/villes/Beziers";
import Sete from "@/pages/villes/Sete";
import Agde from "@/pages/villes/Agde";
import Frontignan from "@/pages/villes/Frontignan";
import Lattes from "@/pages/villes/Lattes";
import ClermontLHerault from "@/pages/villes/ClermontLHerault";
import LaGrandeMotte from "@/pages/villes/LaGrandeMotte";
import CastelnauLeLez from "@/pages/villes/CastelnauLeLez";
import Mauguio from "@/pages/villes/Mauguio";
import Lunel from "@/pages/villes/Lunel";
import Pezenas from "@/pages/villes/Pezenas";
import Meze from "@/pages/villes/Meze";
import Juvignac from "@/pages/villes/Juvignac";
import SaintJeanDeVedas from "@/pages/villes/SaintJeanDeVedas";
import VilleneuveLesMaguelone from "@/pages/villes/VilleneuveLesMaguelone";
import SaintGelyDuFesc from "@/pages/villes/SaintGelyDuFesc";
import LeCres from "@/pages/villes/LeCres";
import Perols from "@/pages/villes/Perols";
import Grabels from "@/pages/villes/Grabels";
import Pignan from "@/pages/villes/Pignan";
import Marseillan from "@/pages/villes/Marseillan";
import BlogIndex from "@/pages/blog/BlogIndex";
import ArticleRoulettesBaie from "@/pages/blog/ArticleRoulettesBaie";
import ArticleBaieQuiCoince from "@/pages/blog/ArticleBaieQuiCoince";
import ArticleBaieVitreeDeraille from "@/pages/blog/ArticleBaieVitreeDeraille";
import ArticlePrixRoulettes from "@/pages/blog/ArticlePrixRoulettes";
import ArticleVoletNeRemontePlus from "@/pages/blog/ArticleVoletNeRemontePlus";
import ArticleVoletElectriquePanne from "@/pages/blog/ArticleVoletElectriquePanne";
import ArticleDoubleVitrageEmbue from "@/pages/blog/ArticleDoubleVitrageEmbue";
import ArticleStoreBanneBloque from "@/pages/blog/ArticleStoreBanneBloque";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      // Silo 1 — Baie coulissante
      {
        path: "/reparation-baie-coulissante-herault/",
        element: <PilierBaieCoulissante />,
      },
      {
        path: "/changer-roulettes-galets-baie-coulissante-herault/",
        element: <RoulettesGalets />,
      },
      {
        path: "/baie-coulissante-qui-coince-herault/",
        element: <BaieQuiCoince />,
      },
      {
        path: "/reparation-rail-baie-coulissante-herault/",
        element: <RailBaie />,
      },
      {
        path: "/reglage-baie-coulissante-herault/",
        element: <ReglageBaie />,
      },
      {
        path: "/serrure-cremone-baie-coulissante-herault/",
        element: <SerrureCremone />,
      },
      {
        path: "/remplacement-baie-coulissante-herault/",
        element: <RemplacementBaie />,
      },
      {
        path: "/double-vitrage-baie-coulissante-herault/",
        element: <DoubleVitrage />,
      },
      // Silo 2 — Volet roulant
      {
        path: "/reparation-volet-roulant-herault/",
        element: <PilierVoletRoulant />,
      },
      {
        path: "/volet-roulant-bloque-herault/",
        element: <VoletBloque />,
      },
      {
        path: "/volet-roulant-ne-remonte-plus-herault/",
        element: <VoletNeRemontePlus />,
      },
      {
        path: "/reparation-moteur-volet-roulant-herault/",
        element: <ReparationMoteur />,
      },
      {
        path: "/changer-sangle-volet-roulant-herault/",
        element: <ChangerSangle />,
      },
      {
        path: "/motorisation-volet-roulant-herault/",
        element: <Motorisation />,
      },
      {
        path: "/volet-roulant-electrique-herault/",
        element: <VoletElectrique />,
      },
      {
        path: "/volet-roulant-solaire-herault/",
        element: <VoletSolaire />,
      },
      // Silo 3 — Vitrage / Vitrier
      {
        path: "/vitrier-herault/",
        element: <PilierVitrier />,
      },
      {
        path: "/remplacement-vitre-cassee-herault/",
        element: <RemplacementVitreCassee />,
      },
      {
        path: "/remplacement-double-vitrage-herault/",
        element: <RemplacementDoubleVitrage />,
      },
      {
        path: "/double-vitrage-embue-herault/",
        element: <DoubleVitrageEmbue />,
      },
      {
        path: "/vitrier-urgence-herault/",
        element: <VitrierUrgence />,
      },
      {
        path: "/miroiterie-herault/",
        element: <Miroiterie />,
      },
      {
        path: "/survitrage-herault/",
        element: <Survitrage />,
      },
      // Silo 4 — Store / BSO
      {
        path: "/reparation-store-herault/",
        element: <PilierStore />,
      },
      {
        path: "/reparation-store-banne-herault/",
        element: <StoreBanne />,
      },
      {
        path: "/store-banne-bloque-herault/",
        element: <StoreBanneBloque />,
      },
      {
        path: "/motorisation-store-herault/",
        element: <MotorisationStore />,
      },
      {
        path: "/reparation-bso-herault/",
        element: <ReparationBSO />,
      },
      {
        path: "/store-electrique-herault/",
        element: <StoreElectrique />,
      },
      // Silo 5 — Fenêtre
      {
        path: "/reparation-fenetre-herault/",
        element: <PilierFenetre />,
      },
      {
        path: "/fenetre-bloquee-herault/",
        element: <FenetreBloquee />,
      },
      {
        path: "/changer-cremone-fenetre-herault/",
        element: <ChangerCremone />,
      },
      {
        path: "/changer-poignee-fenetre-herault/",
        element: <ChangerPoignee />,
      },
      {
        path: "/reglage-oscillo-battant-herault/",
        element: <ReglageOscilloBattant />,
      },
      {
        path: "/changer-joint-fenetre-herault/",
        element: <ChangerJoint />,
      },
      {
        path: "/reparation-fenetre-pvc-alu-bois-herault/",
        element: <FenetrePVCAluBois />,
      },
      // Pages légales et contact
      {
        path: "/mentions-legales/",
        element: <MentionsLegales />,
      },
      {
        path: "/politique-de-confidentialite/",
        element: <PolitiqueConfidentialite />,
      },
      {
        path: "/contact/",
        element: <Contact />,
      },
      // Pages villes
      {
        path: "/depannage-menuiserie-montpellier/",
        element: <Montpellier />,
      },
      {
        path: "/depannage-menuiserie-beziers/",
        element: <Beziers />,
      },
      {
        path: "/depannage-menuiserie-sete/",
        element: <Sete />,
      },
      {
        path: "/depannage-menuiserie-agde/",
        element: <Agde />,
      },
      {
        path: "/depannage-menuiserie-frontignan/",
        element: <Frontignan />,
      },
      {
        path: "/depannage-menuiserie-lattes/",
        element: <Lattes />,
      },
      {
        path: "/depannage-menuiserie-clermont-l-herault/",
        element: <ClermontLHerault />,
      },
      {
        path: "/depannage-menuiserie-la-grande-motte/",
        element: <LaGrandeMotte />,
      },
      {
        path: "/depannage-menuiserie-castelnau-le-lez/",
        element: <CastelnauLeLez />,
      },
      {
        path: "/depannage-menuiserie-mauguio/",
        element: <Mauguio />,
      },
      {
        path: "/depannage-menuiserie-lunel/",
        element: <Lunel />,
      },
      {
        path: "/depannage-menuiserie-pezenas/",
        element: <Pezenas />,
      },
      {
        path: "/depannage-menuiserie-meze/",
        element: <Meze />,
      },
      {
        path: "/depannage-menuiserie-juvignac/",
        element: <Juvignac />,
      },
      {
        path: "/depannage-menuiserie-saint-jean-de-vedas/",
        element: <SaintJeanDeVedas />,
      },
      {
        path: "/depannage-menuiserie-villeneuve-les-maguelone/",
        element: <VilleneuveLesMaguelone />,
      },
      {
        path: "/depannage-menuiserie-saint-gely-du-fesc/",
        element: <SaintGelyDuFesc />,
      },
      {
        path: "/depannage-menuiserie-le-cres/",
        element: <LeCres />,
      },
      {
        path: "/depannage-menuiserie-perols/",
        element: <Perols />,
      },
      {
        path: "/depannage-menuiserie-grabels/",
        element: <Grabels />,
      },
      {
        path: "/depannage-menuiserie-pignan/",
        element: <Pignan />,
      },
      {
        path: "/depannage-menuiserie-marseillan/",
        element: <Marseillan />,
      },
      // Blog
      {
        path: "/blog/",
        element: <BlogIndex />,
      },
      {
        path: "/blog/changer-roulettes-baie-coulissante/",
        element: <ArticleRoulettesBaie />,
      },
      {
        path: "/blog/baie-coulissante-qui-coince-que-faire/",
        element: <ArticleBaieQuiCoince />,
      },
      {
        path: "/blog/baie-vitree-deraille-sort-du-rail/",
        element: <ArticleBaieVitreeDeraille />,
      },
      {
        path: "/blog/prix-reparation-roulettes-baie-vitree/",
        element: <ArticlePrixRoulettes />,
      },
      {
        path: "/blog/volet-roulant-ne-remonte-plus/",
        element: <ArticleVoletNeRemontePlus />,
      },
      {
        path: "/blog/volet-roulant-electrique-en-panne/",
        element: <ArticleVoletElectriquePanne />,
      },
      {
        path: "/blog/double-vitrage-embue/",
        element: <ArticleDoubleVitrageEmbue />,
      },
      {
        path: "/blog/store-banne-bloque-que-faire/",
        element: <ArticleStoreBanneBloque />,
      },
      {
        path: "/merci/",
        element: <Merci />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;